module.exports = __webpack_public_path__ + "img/minimizeright.400be41a.svg";